import { render } from "./PromptSearchForm.vue?vue&type=template&id=2ace104a&scoped=true"
import script from "./PromptSearchForm.vue?vue&type=script&lang=js"
export * from "./PromptSearchForm.vue?vue&type=script&lang=js"

import "./PromptSearchForm.vue?vue&type=style&index=0&id=2ace104a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ace104a"]])

export default __exports__